// AI Generated: Business Benefits component matching Figma design (node-id=1279-1785)
import React from 'react';
import styles from '$styles/ind/home/businessBenefits.module.scss';

interface IBusinessBenefitsProps {
  isMobile?: boolean;
  isDesktop?: boolean;
}

// AI Generated: Updated to match Figma node-id=1691-521
const BusinessBenefits: React.FC<IBusinessBenefitsProps> = () => {
  const benefits = [
    {
      id: 1,
      image: '/public/images/cards/card-30-percen.svg',
      title: '30%+ annual returns with weekly payments',
      description: 'Get weekly payments with high profits in the growing bus market',
    },
    {
      id: 2,
      image: '/public/images/cards/card-50l-travelers.svg',
      title: '50L+ Travelers & growing every day in market',
      description: 'The bus market is growing fast at 18% giving you more bookings',
    },
    {
      id: 3,
      image: '/public/images/cards/card-online-operations.svg',
      title: 'Online operations makes it zero hassle',
      description: 'Operate easily with getting permits, bookings, & payments',
    },
    {
      id: 4,
      image: '/public/images/cards/card-1000-routes.svg',
      title: '1000+ Untapped routes gives big opportunity',
      description: 'Find profitable new routes with smart pricing & operational tools',
    },
  ];
  // AI Generated: End of update

  return (
    <section className={styles.businessBenefits} id="benefits">
      <div className={styles.container}>
        {/* Header Section */}
        <div className={styles.header}>
          <div className={styles.headerText}>
            <h2 className={styles.sectionTitle}>
              Why <span className={styles.nowText}>now</span> is the{' '}
              <span className={styles.highlightText}>time to start</span> bus business
            </h2>
            <p className={styles.sectionSubtitle}>
              Your chance to profit from India's growing travel market
            </p>
          </div>
          <a href="/learn" className={styles.ctaButton}>Get Started</a>
        </div>

        {/* Benefits Cards */}
        <div className={styles.benefitsGrid}>
          {benefits.map((benefit) => (
            <div key={benefit.id} className={styles.benefitCard}>
              <div className={styles.cardImage}>
                <img
                  src={benefit.image}
                  alt={benefit.title}
                  className={styles.benefitImage}
                  loading="lazy"
                />
              </div>
              <div className={styles.cardBody}>
                <h3 className={styles.benefitTitle}>{benefit.title}</h3>
                <p className={styles.benefitDescription}>{benefit.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BusinessBenefits;
// AI Generated: End of business benefits component


